import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-pan-adhar-pan",
  templateUrl: "./pan-adhar-home.component.html",
  styleUrls: ["./pan-adhar-home.component.scss"],
})
export class PanAdharUpdateDetails implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading = false;
  lotteryList: {[key: number]: string};
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  applicationNo: string = '';
  panData:any;

  isUpdatePanDetailsEnable:boolean = false;

  firstDropdownSelection: FormControl = new FormControl('');
  secondDropDownSelection: FormControl = new FormControl('');


   
  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService:ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService
    , private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }



  selectedOption: FormControl = new FormControl('');
  formGroup: FormGroup = new FormGroup({
    selectedOption: this.selectedOption
  });

  // Define the options for the Aadhar details select box
  aadharOptions: string[] = ['Aadhar Option 1', 'Aadhar Option 2', 'Aadhar Option 3'];

  loadData() {



    this.publishLetterService
    .publishDocumentsInitForm()
    .subscribe((data: any) => {
       this.isLoading = false;
        this.lotteryList = data.lotteryList;
    }, error => {
      this.isLoading = false;
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    });
  
  }

 
  refresh() {
    this.loadData();
  }

  refresh1() {
    this.fetchSpousePanDetails()
    // window.location.reload();
  }

  async successToast(msg:any) {
    await this._snackBar.open(
        msg,
        "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
        }
    );
}

// async mysuccessToast(msg:any) {
//   await this._snackBar.open(
//       msg,
//       "Close", {
//       horizontalPosition: "right",
//       verticalPosition: "top",
//       panelClass: "success-toast",
//       duration: 3 * 1000,
//       }
//   );
// }

// async myErrorToast(msg:any) {
//   await this._snackBar.open(
//       msg,
//       "Close", {
//       horizontalPosition: "right",
//       verticalPosition: "top",
//       panelClass: "error-toast",
//       duration: 3 * 1000,
//       }
//   );
// }

async errorToast(msg:any) {
  await this._snackBar.open(
      msg,
      "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
      }
  );
}


fetchSpousePanDetails() {
    console.log(this.applicationNo);
    this.isLoading = true;
    this.auditTrailService.fetchSpousePanDetailsService({applicationNo:this.applicationNo})
    .subscribe((data) => {
       console.log(data,"=========>");
      this.isLoading = false;
      this.panData = data;
      // if(data.status === 'SUCCESS') {
      //   this.successToast(data.successMsg);

      //   this.applicationNo ='';
      // }
      // else {
      //   this.errorToast(data.errorMessage); 
      //   this.applicationNo ='';
      // }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
 
}

// updateSpousePanDetails() {
//   console.log(this.applicationNo);
//   this.isLoading = true;
//   this.auditTrailService.updateSpousePanDetailsService({applicationNo:this.applicationNo})
//   .subscribe((data) => {
//      console.log(data,"=========>");
//     this.isLoading = false;
//     this.panData = data;
//     if(data.status === 'SUCCESS') {
//       // this.successToast("data.successMsg");
//       this.successToast("Spouse Pan Name Updated Successfully");


//      // this.applicationNo ='';
//     }
//     else {
//       this.errorToast(data.errorMessage); 
//       this.applicationNo ='';
//     }
//   }, error => {
//     this.isLoading = false;
//     this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
//   });

// }


// fetchSpousePanDetails() {
//   console.log(this.applicationNo);
//   this.auditTrailService.fetchSpousePanDetailsService({ applicationNo: this.applicationNo })
//     .subscribe((data) => {
//       this.isLoading = false;
//       console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",data);
//       if (data.status === 'SUCCESS') {
//         this.successToast(data.successMsg);
//         this.applicationNo = '';
//       } else {
//         this.errorToast(data.errorMessage); 
//         this.applicationNo = '';
//       }
//     }, error => {
//       this.isLoading = false;
//       this.exportImportService.errorToast(error?.error?.message || error?.errorMessage || error?.error?.errorMessage);
//     });
// }

  toggle(updatePanBtn:any){
      this.isUpdatePanDetailsEnable = updatePanBtn.checked;
  }


  saveSelectedValue(event: any) {
    const selectedValue = event.value;
    localStorage.setItem('selectedAadharType', selectedValue);
  }

}